import React from "react";
import { Link, useLocation } from "react-router-dom";

const routeNames = {
    "/": "Home",
    "wohnen": "Wohnen",
    "siedlungen": "Siedlungen",
    "siedlungen-detail": "Albisrieden, Zürich",
    "wohnen-in-der-bgz": "Wohnen in der BGZ",
    "anmeldung-wohnen": "Anmeldung Mietinteresse Wohnung",
    "dokumente-reglemente": "Dokumente & Reglemente",
    "formulare-wohnen": "Formulare",
    "tipps-und-tricks": "Tipps & Tricks",
    "hauswartung-notfall": "Hauswartung",
    "fragen-antworten": "Fragen & Antworten",
    "freie-mietobjekte": "Freie Mietobjekte",
    "freie-mietobjekte-detail": "Parkplatz",
    "bauprojekte": "Bauprojekte",
    "neubauprojekte": "Neubauprojekte",
    "neubauprojektedetail": "Tödi Horgen Mehrgenerationen-siedlung",
    "sanierungen": "Sanierungen",
    "sanierungen-detail": "Siedlung Rautihalde Zürich",
    "grundstueck-verkaufen": "Grundstück verkaufen",
    "genossen-schaft": "Genossen Schaft",
    "portraet": "Portrait",
    "team": "Team",
    "genossenschafter": "Genossenschafter",
    "geschichte": "Geschichte",
    "soziales-engagement": "Soziales Engagement",
    "jobs": "Jobs",
    "datenschutz": "Datenschutz",
    "impressum": "Impressum",
    "medien": "Medien",
    "aktuelles": "Aktuelles",
    "aktuelles-detail": "Willkommen Jasmin Meier"
};

const Breadcrumbs = ({ activePage = "", buttonText = "", activeLink = "/", activeInnerPage = "", sectionClass, bgGray = false }) => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter(x => x);

    return (
        <>
            {activePage && <div className='container'>
                <nav aria-label="breadcrumb">
                    <ul className={`breadcrumb mb-0 ${sectionClass}`}>
                        <li className="breadcrumb-item">
                            <Link to="/"><img src="https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg" alt="Home" /></Link>
                        </li>
                        {activePage && <li className="breadcrumb-item active">
                            <a rel="noopener noreferrer">{activePage.charAt(0).toUpperCase() + activePage.slice(1)}</a>
                        </li>}
                        {activeInnerPage && <li className="breadcrumb-item active">
                            <Link to={`/${activeInnerPage.toLowerCase() === "wohnen in der bgz" ? 'wohnen-in-der-bgz' : activeInnerPage.toLowerCase().replace(/\s+/g, "-")}`}>{activeInnerPage.charAt(0).toUpperCase() + activeInnerPage.slice(1)}</Link>
                        </li>}
                        {buttonText &&
                            buttonText === "Die innovative Genossenschaft" ? (
                            <li className="breadcrumb-item">
                                Porträt
                            </li>
                        ) : buttonText === "Alles rund ums Wohnen" ? (
                            <li className="breadcrumb-item">
                                Wohnen in der BGZ
                            </li>
                        ) : (buttonText &&
                            <li className="breadcrumb-item">
                                {buttonText.length > 20
                                    ? `${buttonText.slice(0, 20)}...`
                                    : buttonText}
                            </li>
                        )}
                        {/* {pathnames.map((value, index) => {
                        const to = "/" + pathnames.slice(0, index + 1).join("/");
                        const isLast = index === pathnames.length - 1;
                        const label = routeNames[value] || value.replace(/-/g, " ");
                        return (
                        <li key={to} className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                            {isLast ? (
                            label
                            ) : (
                            <Link to={to}>{label}</Link>
                            )}
                        </li>
                        );
                    })} */}
                    </ul>
                </nav>
            </div>}
        </>
    );
};

export default Breadcrumbs;